import { createElementBlock as t, openBlock as l, createElementVNode as c } from "vue";
import e from "./index289.js";
const r = {}, a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function n(s, o, m, p, f, i) {
  return l(), t("svg", a, o[0] || (o[0] = [
    c("path", {
      fill: "currentColor",
      d: "M12 2.25a7.623 7.623 0 0 1 7.623 7.623v.172c0 2.53-1.864 5.757-4.601 9.11l-.56.672c-.38.45-.773.9-1.18 1.35a1.723 1.723 0 0 1-2.564.001l-.6-.676a54.91 54.91 0 0 1-.58-.675l-.56-.672c-2.737-3.353-4.601-6.58-4.601-9.11v-.172a7.626 7.626 0 0 1 7.374-7.619Zm0 1.5-.211.004a6.123 6.123 0 0 0-5.912 6.119v.172c0 1.877 1.45 4.527 3.6 7.316l.488.622c.25.312.508.625.773.938l.539.627c.182.209.368.418.555.626a.223.223 0 0 0 .336 0c.188-.208.373-.417.555-.626l.539-.627c2.825-3.341 4.861-6.65 4.861-8.876v-.172A6.123 6.123 0 0 0 12 3.75Zm0 3.418a2.75 2.75 0 0 1 2.745 2.582l.005.205a2.75 2.75 0 0 1-5.495.168l-.005-.205a2.75 2.75 0 0 1 2.582-2.745L12 7.168Zm0 1.5a1.25 1.25 0 0 0-1.244 1.122l-.007.146.001.019c0 .648.491 1.18 1.122 1.244l.128.006a1.25 1.25 0 0 0 1.244-1.122l.006-.128v-.037c0-.69-.56-1.25-1.25-1.25Z"
    }, null, -1)
  ]));
}
const d = /* @__PURE__ */ e(r, [["render", n]]);
export {
  d as default
};
